import { blogSlice } from "./store/blog.slice";
import {
  blogApi,
  useGetBlogsQuery,
  useCreateBlogMutation,
  useUpdateBlogMutation,
  useLazyGetBlogByIdQuery,
  useLazyGetBlogsQuery,
  useDeleteBlogMutation
} from "./api/blog.api";

export const { setBlogs } = blogSlice.actions;

export {
  blogApi,
  blogSlice,
  useGetBlogsQuery,
  useCreateBlogMutation,
  useUpdateBlogMutation,
  useLazyGetBlogByIdQuery,
  useLazyGetBlogsQuery,
  useDeleteBlogMutation
};
